import * as normalize from 'utils/normalize';
import getPatientName from 'utils/print/getPatientName';
import getPatientFullAddress from 'utils/print/getPatientFullAddress';
import getPatientPhone1 from 'utils/print/getPatientPhone1';
import getPatientPhone2 from 'utils/print/getPatientPhone2';
import getPatientPhone3 from 'utils/print/getPatientPhone3';
import getPatientMedicareID from 'utils/print/getPatientMedicareID';
import getOrderLinePlaceOfService from 'utils/print/getOrderLinePlaceOfService';
import getPatientDob1 from 'utils/print/getPatientDob1';
import getPatientDob2 from 'utils/print/getPatientDob2';
import getPatientDob3 from 'utils/print/getPatientDob3';
import getPatientGender from 'utils/print/getPatientGender';
import getPatientHeightIn from 'utils/print/getPatientHeightIn';
import getPatientWeight from 'utils/print/getPatientWeight';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberFullAddress from 'utils/print/getPrescriberFullAddress';
import getPrescriberPhone1 from 'utils/print/getPrescriberPhone1';
import getPrescriberPhone2 from 'utils/print/getPrescriberPhone2';
import getPrescriberPhone3 from 'utils/print/getPrescriberPhone3';
import getPrescriberNPI from 'utils/print/getPrescriberNPI';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getSupplierName from 'utils/print/getSupplierName';
import getSupplierFullAddress from 'utils/print/getSupplierFullAddress';
import getSupplierPhone1 from 'utils/print/getSupplierPhone1';
import getSupplierPhone2 from 'utils/print/getSupplierPhone2';
import getSupplierPhone3 from 'utils/print/getSupplierPhone3';
import getSupplierNSCorNPI from 'utils/print/getSupplierNSCorNPI';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineNarrativeDescriptionAndCost from 'utils/print/getOrderLineNarrativeDescriptionAndCost';
import getSignature from 'utils/print/getSignature';

const CMS846 = {
  ID: 4,
  Name: 'CMS-846 Pneumatic Compression Device',
  Type: 'CMS',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/CMS-846/1.js',
      fields: [
        {
          name: 'Certification Type/Date INITIAL 1',
          type: 'text',
          x: 89,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date INITIAL 2',
          type: 'text',
          x: 96,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date INITIAL 3',
          type: 'text',
          x: 103,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 1',
          type: 'text',
          x: 125,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 2',
          type: 'text',
          x: 132,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 3',
          type: 'text',
          x: 139,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 1',
          type: 'text',
          x: 175,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 2',
          type: 'text',
          x: 182,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 3',
          type: 'text',
          x: 189,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 15,
          y: 41,
          width: 96,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: getPatientFullAddress,
          x: 15,
          y: 44.5,
          width: 96,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Phone 1',
          type: 'text',
          getValue: getPatientPhone1,
          x: 16,
          y: 53,
          width: 10,
        },
        {
          name: 'Phone 2',
          type: 'text',
          getValue: getPatientPhone2,
          x: 28,
          y: 53,
          width: 10,

        },
        {
          name: 'Phone 3',
          type: 'text',
          getValue: getPatientPhone3,
          x: 41,
          y: 53,
          width: 14,
        },
        {
          name: 'Medicare ID',
          type: 'text',
          getValue: getPatientMedicareID,
          x: 72,
          y: 53,
          width: 39,
        },
        {
          name: 'Supplier Name and Address',
          type: 'text',
          getValue: (props) => {
            if (props.value) {
              return props.value;
            }
            return `${getSupplierName(props)}, ${getSupplierFullAddress(props)}`;
          },
          x: 115,
          y: 40.5,
          width: 86,
          height: 13,
          multiline: true,
        },
        {
          name: 'Supplier Phone 1',
          type: 'text',
          getValue: getSupplierPhone1,
          x: 116.5,
          y: 53,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Supplier Phone 2',
          type: 'text',
          getValue: getSupplierPhone2,
          x: 128,
          y: 53,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Supplier Phone 3',
          type: 'text',
          getValue: getSupplierPhone3,
          x: 141,
          y: 53,
          width: 14,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Supplier NSC or NPI',
          type: 'text',
          getValue: getSupplierNSCorNPI,
          x: 174,
          y: 53,
          width: 27,
        },
        {
          name: 'Place Of Service',
          type: 'text',
          getValue: props => getOrderLinePlaceOfService({ ...props, index: 0 }),
          x: 40,
          y: 58,
          width: 19,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 1',
          type: 'text',
          getValue: getPatientDob1,
          x: 125.5,
          y: 58,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 2',
          type: 'text',
          getValue: getPatientDob2,
          x: 132.5,
          y: 58,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 3',
          type: 'text',
          getValue: getPatientDob3,
          x: 139,
          y: 58,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Gender',
          type: 'text',
          getValue: getPatientGender,
          x: 152,
          y: 58,
          width: 5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Height',
          type: 'text',
          getValue: getPatientHeightIn,
          x: 172,
          y: 58,
          width: 6,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Patient Weight',
          type: 'text',
          getValue: getPatientWeight,
          x: 190,
          y: 58,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 1',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 0 }),
          x: 75,
          y: 64.5,
          width: 22,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 2',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 1 }),
          x: 75,
          y: 69.6,
          width: 22,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 3',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 2 }),
          x: 75,
          y: 74.7,
          width: 22,
        },
        {
          name: 'Supply Item/Service Procedure Code(s) 4',
          type: 'text',
          getValue: props => getOrderLineHCPCSCode({ ...props, index: 3 }),
          x: 75,
          y: 79.8,
          width: 22,
        },
        {
          name: 'Prescriber Name',
          type: 'text',
          getValue: getPrescriberName,
          x: 115,
          y: 67.6,
          width: 86,
        },
        {
          name: 'Prescriber Email',
          type: 'text',
          getValue: getPrescriberFullAddress,
          x: 115,
          y: 70.7,
          width: 86,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Prescriber Phone 1',
          type: 'text',
          getValue: getPrescriberPhone1,
          x: 117,
          y: 80.5,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber Phone 2',
          type: 'text',
          getValue: getPrescriberPhone2,
          x: 128,
          y: 80.5,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber Phone 3',
          type: 'text',
          getValue: getPrescriberPhone3,
          x: 142,
          y: 80.5,
          width: 14,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber NSC or NPI',
          type: 'text',
          getValue: getPrescriberNPI,
          x: 176,
          y: 80.5,
          width: 25,
        },
        {
          name: 'EST LENGTH OF NEED',
          type: 'text',
          x: 67,
          y: 94,
          width: 9,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'DIAGNOSIS CODES',
          type: 'text',
          getValue: getDiagnosisCode,
          x: 148,
          y: 94,
          width: 53,
        },
        {
          name: 'Does the patient have chronic venous insufficiency with venous stasis ulcers?',
          type: 'radio',
          options: [
            {
              x: 20,
              y: 110.5,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 31,
              y: 110.5,
              width: 2,
              height: 2,
              value: 'N',
            },
          ],
        },
        {
          name: 'If the patient has venous stasis ulcers, have you seen the patient regularly over the past six months and treated the ulcers with a compression bandage system or compression garment?',
          type: 'radio',
          options: [
            {
              x: 20,
              y: 118,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 31,
              y: 118,
              width: 2,
              height: 2,
              value: 'N',
            },
          ],
        },
        {
          name: 'Has the patient had radical cancer surgery or radiation for cancer that interrupted normal lymphatic drainage of the extremity?',
          type: 'radio',
          options: [
            {
              x: 20,
              y: 129,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 31,
              y: 129,
              width: 2,
              height: 2,
              value: 'N',
            },
          ],
        },
        {
          name: 'Does the patient have a malignant tumor with obstruction of the lymphatic drainage of an extremity?',
          type: 'radio',
          options: [
            {
              x: 20,
              y: 137,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 31,
              y: 137,
              width: 2,
              height: 2,
              value: 'N',
            },
          ],
        },
        {
          name: 'Has the patient had lymphedema since childhood or adolescence?',
          type: 'radio',
          options: [
            {
              x: 20,
              y: 144,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 31,
              y: 144,
              width: 2,
              height: 2,
              value: 'N',
            },
          ],
        },
        {
          name: 'NAME OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 26,
          y: 153,
          width: 62,
        },
        {
          name: 'TITLE OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 99,
          y: 153,
          width: 40,
        },
        {
          name: 'EMPLOYER OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 157,
          y: 153,
          width: 43,
        },
        {
          name: '(1) Narrative description of all items, accessories and options ordered; (2) Supplier’s charge; and (3) Medicare Fee Schedule Allowance for each item, accessory, and option',
          type: 'text',
          getValue: getOrderLineNarrativeDescriptionAndCost,
          x: 15,
          y: 174,
          width: 186,
          height: 52,
          multiline: true,
        },
        {
          name: 'Signature',
          type: 'signature',
          getValue: getSignature,
          x: 50,
          y: 249,
          width: 90,
          height: 10,
        },
        {
          name: 'Date 1',
          type: 'text',
          x: 162,
          y: 255,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 2',
          type: 'text',
          x: 170,
          y: 255,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 3',
          type: 'text',
          x: 178,
          y: 255,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
      ],
    },
  ],
};

export default CMS846;



// WEBPACK FOOTER //
// ./src/config/documents/CMS-846.js